module.exports = __webpack_public_path__ + "img/download_banner.d01de7fd.jpeg";